import { forwardRef } from "react";

import { fastLinkButtonVariants } from "@components/fastFields/fastLinkButton/variants";
import type { IFastLinkButtonProps } from "@components/fastFields/fastLinkButton/types";
import { LinkButton } from "@components/molecules/linkButton";
import { useParseTranslationString } from "@/hooks/useParseTranslationString";

export const FastLinkButton = forwardRef<
  HTMLButtonElement,
  IFastLinkButtonProps
>(({ type, label: propsLabel, ...restButtonProps }, ref) => {
  const { parseTranslatableString } = useParseTranslationString([
    "action",
    "common",
    "page",
  ] as const);

  const { label: variantsLabel, ...variantProps } =
    fastLinkButtonVariants[type];

  const label = propsLabel || variantsLabel;

  return (
    <LinkButton
      label={parseTranslatableString(label)}
      {...variantProps}
      {...restButtonProps}
      ref={ref}
    />
  );
});

FastLinkButton.displayName = "FastLinkButton";
